import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import PropTypes from "prop-types";

export default function ModalTerms({ open, onClose, onAccept }) {
  const [accepted, setAccepted] = useState(false);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md" scroll="paper">
      <DialogTitle
        sx={{
          background: "linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
          color: "#fff",
          textShadow: "0px 2px 4px rgba(0,0,0,0.5)",
        }}
      >
        TÉRMINOS Y CONDICIONES
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          1. Reclamos y Plazos
        </Typography>
        <Typography variant="body2" paragraph>
          • Para reclamos de pagos y devoluciones:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Plazo de 24 horas para comunicarse con soporte técnico
          - Debe incluir número de referencia y comprobante de pago
          - Las devoluciones solo aplican si los tickets no han sido validados
          - Los reclamos deben realizarse a través de la plataforma o correo oficial
        </Typography>
        <Typography variant="body2" paragraph>
          • Para reclamar premios:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Plazo de 72 horas desde la publicación del ganador
          - Debe presentar identificación vigente
          - Debe presentar comprobante de compra original
          - El premio caduca después del plazo establecido
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          2. Compra y Tickets
        </Typography>
        <Typography variant="body2" paragraph>
          • Requisitos de compra:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Compra mínima de 2 tickets
          - Pago debe realizarse en la moneda especificada
          - Debe proporcionar datos de contacto válidos
          - Cédula válida (7-9 dígitos)
          - Correo electrónico válido
          - Teléfono válido (formato: +584141234567 o 04141234567)
        </Typography>
        <Typography variant="body2" paragraph>
          • Asignación y envío de tickets:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Los tickets se asignan automáticamente (números más bajos disponibles)
          - Se pueden visualizar inmediatamente en la plataforma
          - Envío por correo electrónico en 24-48 horas hábiles
          - Es responsabilidad del usuario verificar la recepción
        </Typography>
        <Typography variant="body2" paragraph>
          • Estados de los tickets:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Reservado: Al realizar el pago
          - Validado: Al confirmar el pago
          - Liberado: Al rechazar el pago
          - No transferible una vez validado
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          3. Validación de Pagos
        </Typography>
        <Typography variant="body2" paragraph>
          • Proceso de validación:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Validación manual por equipo especializado
          - Plazo máximo de 24 horas hábiles
          - Notificación automática del resultado
          - Actualización inmediata del estado
        </Typography>
        <Typography variant="body2" paragraph>
          • Manejo de pagos rechazados:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Liberación automática de tickets
          - Notificación al comprador
          - Necesario nuevo pago para reservar
          - No se garantiza disponibilidad de números
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          4. Requisitos de Participación
        </Typography>
        <Typography variant="body2" paragraph>
          • Edad y ubicación:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Mayores de 18 años
          - Participación válida en territorio venezolano
          - Identificación vigente requerida
        </Typography>
        <Typography variant="body2" paragraph>
          • Aparición en redes sociales:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Obligatorio para ganadores
          - Incluye fotos y videos con el premio
          - Se utilizará en todas las redes oficiales
          - No se permite edición o modificación del contenido
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          5. Entrega de Premios
        </Typography>
        <Typography variant="body2" paragraph>
          • Proceso de entrega:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Plazo máximo de 15 días hábiles
          - Incluye factura y garantía oficial
          - Entrega personal o por servicio de mensajería
          - Costos de envío a cargo del ganador si aplica
        </Typography>
        <Typography variant="body2" paragraph>
          • Documentación requerida:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Comprobante de compra original
          - Identificación vigente
          - Formulario de reclamación completado
          - Autorización para uso de imagen
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          6. Propiedad Intelectual
        </Typography>
        <Typography variant="body2" paragraph>
          • Uso de marca:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Prohibido uso sin autorización escrita
          - Incluye nombre, logos y materiales
          - Se tomarán acciones legales por uso no autorizado
          - Derechos reservados en su totalidad
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          7. Protección de Datos
        </Typography>
        <Typography variant="body2" paragraph>
          • Uso de información:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Solo para gestión de compras y premios
          - Almacenamiento en servidores seguros
          - No se comparte con terceros
          - Derecho a solicitar eliminación de datos
        </Typography>
        <Typography variant="body2" paragraph>
          • Seguridad:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Encriptación de datos sensibles
          - Acceso restringido a personal autorizado
          - Actualización regular de medidas de seguridad
          - Cumplimiento con normativas de protección de datos
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          8. Seguridad de la Plataforma
        </Typography>
        <Typography variant="body2" paragraph>
          • Medidas de seguridad:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Encriptación SSL en todas las transacciones
          - Protección contra fraudes
          - Monitoreo constante de actividades
          - Respaldo regular de datos
        </Typography>
        <Typography variant="body2" paragraph>
          • Responsabilidades:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - No nos hacemos responsables de fallos en conexión
          - No nos hacemos responsables de errores en dispositivos
          - No nos hacemos responsables de pérdida de credenciales
          - No nos hacemos responsables de retrasos en servicios externos
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          9. Soporte Técnico
        </Typography>
        <Typography variant="body2" paragraph>
          • Disponibilidad:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Lunes a Viernes: 9:00 AM - 5:00 PM
          - Respuesta en 24 horas hábiles
          - Múltiples canales de contacto
        </Typography>
        <Typography variant="body2" paragraph>
          • Canales de soporte:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Correo: ganaconbendicionenmanos@gmail.com
          - WhatsApp: [número]
          - Plataforma web: Sección de Ayuda
          - Redes sociales oficiales
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          10. Modificaciones
        </Typography>
        <Typography variant="body2" paragraph>
          • Nos reservamos el derecho de:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Modificar estos términos en cualquier momento
          - Actualizar políticas de seguridad
          - Cambiar procesos de validación
          - Ajustar plazos y condiciones
        </Typography>
        <Typography variant="body2" paragraph>
          • Notificaciones:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Cambios publicados en la plataforma
          - Comunicación por correo electrónico
          - Avisos en redes sociales oficiales
          - Entran en vigor inmediatamente
        </Typography>

        <Typography variant="h6" gutterBottom sx={{ color: "primary.main", fontWeight: "bold" }}>
          Contacto
        </Typography>
        <Typography variant="body2" paragraph>
          Para dudas o aclaraciones:
        </Typography>
        <Typography variant="body2" paragraph sx={{ pl: 4 }}>
          - Correo: ganaconbendicionenmanos@gmail.com
          - WhatsApp: [número]
          - Horario: Lunes a Viernes, 9:00 AM - 5:00 PM
          - Tiempo de respuesta: 24 horas hábiles
        </Typography>

        <Typography variant="body2" paragraph sx={{ mt: 4, textAlign: "right" }}>
          Fecha de última actualización: 20 de mayo de 2025
        </Typography>

        <Box sx={{ mt: 3 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                color="primary"
              />
            }
            label="He leído y acepto los términos y condiciones"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          sx={{
            color: "text.secondary",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
          }}
        >
          Cerrar
        </Button>
        <Button
          onClick={() => {
            if (accepted) {
              onAccept();
            }
          }}
          variant="contained"
          disabled={!accepted}
          sx={{
            background: "linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
            color: "#fff",
            textShadow: "0px 1px 2px rgba(0,0,0,0.5)",
            borderRadius: "0.5rem",
            "&:hover": { filter: "brightness(1.1)" },
            "&.Mui-disabled": {
              background: "linear-gradient(90deg, #830095 0%, #830095 33%, #830095 66%, #830095 100%)",
              color: "rgba(255, 255, 255, 0.7)",
            },
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalTerms.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
};
